import includes from 'lodash/includes'

import { matchText } from 'modules/core/lib/stringUtils'

import ReportStruct from 'modules/reports/lib/ReportStruct'
import templates from 'modules/reports/store/collections/templates'
import type Template from 'modules/reports/store/models/Template'

interface Props {
  search: string
  selectedCategories: string[]
}

const useTemplates = ({ search, selectedCategories }: Props): ReportStruct<Template>[] => {
  const noSelected = !selectedCategories.length

  return templates.models
    .filter(
      (template: Template) =>
        matchText(search, template.title) &&
        (noSelected || includes(selectedCategories, template.attributes.category_slug))
    )
    .map((template) => ReportStruct.buildFromTemplate(template))
}

export default useTemplates
